"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgInstantConfirmFlat = function SvgInstantConfirmFlat(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    className: "instant-confirm-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 22"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2080F1"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a) #009df9",
    fillRule: "evenodd",
    d: "m291.237 3071-9.075 12.238 3.218.19-1.276 8.959 8.898-12.964-2.936-.202z",
    transform: "translate(-282 -3071)"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgInstantConfirmFlat);
var _default = Memo;
exports["default"] = _default;